import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  listOrderForTenant,
  getTotalDeliveryCost,
  getCheckoutHistory,
  listOrderForSeller,
  listOrderForManufacturer,
  updatePickupTime,
  getPartner30daysorderscount,
  getTenant30daysorderscount,
  getPartnerSalesGroup,
  getTenantSalesGroup,
  listOrderForAllUsers,
  getOrderDetails,
  setDeliveryAgent,
  getInvoiceData,
  updateShippingOrder,
} from "@/services/order.js";
import Axios from "axios";

@Module({
  namespaced: true,
})
export default class Order extends VuexModule {
  public tenantOrders = [];
  public sellerOrders = [];
  public manufacturerOrders = [];
  public checkoutHistory = [];
  public listOrderAllUsers = [];
  public orderDetailsData = [];
  public invoiceDetails = [];

  @Action
  public async setDeliveryAgent(payload) {
    try {
      const data = await setDeliveryAgent(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async cleanOrderList() {
    this.context.commit("cleanOrderListMutation");
  }

  @Action
  public async listOrderForAllUsers(payload) {
    try {
      const data = await listOrderForAllUsers(payload);
      this.context.commit("setlistOrderForAllUsers", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async getOrderDetails(payload) {
    try {
      const data = await getOrderDetails(payload);
      this.context.commit("setOrderDetailsData", data.data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchCheckoutHistory(payload) {
    try {
      const data = await getCheckoutHistory(payload);
      this.context.commit("setCheckoutHistory", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchOrderForTenant(payload) {
    try {
      const data = await listOrderForTenant(payload);
      this.context.commit("setTenantOrders", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchOrderForSeller(payload) {
    try {
      const data = await listOrderForSeller(payload);
      this.context.commit("setSellerOrders", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchOrderForManufacturer(payload) {
    try {
      const data = await listOrderForManufacturer(payload);
      this.context.commit("setManufacturerOrders", data.response);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async updatePickupTime(payload) {
    try {
      const data = await updatePickupTime(payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchPartner30daysorderscount() {
    try {
      const data = await getPartner30daysorderscount();
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchTenant30daysorderscount(Id) {
    try {
      const data = await getTenant30daysorderscount(Id);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchPartnerSalesGroup() {
    try {
      const data = await getPartnerSalesGroup();
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchTenantSalesGroup(Id) {
    try {
      const data = await getTenantSalesGroup(Id);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchTotalDeliveryCost() {
    try {
      const data = await getTotalDeliveryCost();
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async fetchInvoiceData(orderId) {
    try {
      const data = await getInvoiceData(orderId);
      this.context.commit("setInvoiceData", data);
      return data;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async acceptCurrentOrder(payload) {
    const data: any = sessionStorage.getItem("userLogin");
    const { token } = JSON.parse(data);
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    try {
      const response = await Axios.post(payload.url, payload.data, {
        headers: headers,
      });
      return response.data;
    } catch (error) {
      throw error.response;
    }
  }
  @Action
  public async updateShippingOrder({ orderId, payload }) {
    try {
      const data = await updateShippingOrder(orderId, payload);
      // this.context.commit("setUpdatedShippingOrder", data);
      return data;
    } catch (error) {
      throw error;
    }
  }


  // mutations

  @Mutation
  public cleanOrderListMutation() {
    this.tenantOrders = [];
    this.sellerOrders = [];
    this.manufacturerOrders = [];
    this.listOrderAllUsers = [];
    this.orderDetailsData = [];
  }

  @Mutation
  public setCheckoutHistory(data: any) {
    this.checkoutHistory = data;
  }

  @Mutation
  public setTenantOrders(data: any) {
    this.tenantOrders = data;
  }

  @Mutation
  public setSellerOrders(data: any) {
    this.sellerOrders = data;
  }

  @Mutation
  public setlistOrderForAllUsers(data: any) {
    this.listOrderAllUsers = data;
  }

  @Mutation
  public setOrderDetailsData(data: any) {
    this.orderDetailsData = data;
  }

  @Mutation
  public setManufacturerOrders(data: any) {
    this.manufacturerOrders = data;
  }

  @Mutation
  public setInvoiceData(data: any) {
    this.invoiceDetails = data;
  }

  // getters
  get GetTenantOrders() {
    return this.tenantOrders;
  }

  get GetSellerOrders() {
    return this.sellerOrders;
  }

  get GetManufacturerOrders() {
    return this.manufacturerOrders;
  }

  get GetCheckoutHistory() {
    return this.checkoutHistory;
  }

  get GetListOrderAllUsers() {
    return this.listOrderAllUsers;
  }

  get GetInvoiceData() {
    return this.invoiceDetails;
  }

  get GetOrderDetails() {
    return this.orderDetailsData;
  }
}
